export default {"src":"/_next/static/media/nodeBanner.bf9f8a70.svg","height":289,"width":1054};